// ==============================|| OVERRIDES - CHIP ||============================== //

export default function Chip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          },
          '&:active': {
            boxShadow: 'none',
            transform: 'scale(1)'
          }
        },
        sizeSmall: {
          height: 24,
          fontSize: '0.75rem',
          '& .MuiChip-label': {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
          }
        },
        sizeMedium: {
          height: 32,
          fontSize: '0.875rem'
        },
        sizeLarge: {
          fontSize: '1rem',
          height: 40
        },
        filled: {
          '&.MuiChip-colorPrimary': {
            backgroundColor: theme.palette.primary.lighter || 'rgba(33, 150, 243, 0.15)',
            color: theme.palette.primary.main,
          },
          '&.MuiChip-colorSecondary': {
            backgroundColor: theme.palette.secondary.lighter || 'rgba(156, 39, 176, 0.15)',
            color: theme.palette.secondary.main,
          },
          '&.MuiChip-colorError': {
            backgroundColor: theme.palette.error.lighter || 'rgba(244, 67, 54, 0.15)',
            color: theme.palette.error.main,
          },
          '&.MuiChip-colorSuccess': {
            backgroundColor: theme.palette.success.lighter || 'rgba(76, 175, 80, 0.15)',
            color: theme.palette.success.main,
          },
          '&.MuiChip-colorWarning': {
            backgroundColor: theme.palette.warning.lighter || 'rgba(255, 152, 0, 0.15)',
            color: theme.palette.warning.main,
          },
          '&.MuiChip-colorInfo': {
            backgroundColor: theme.palette.info.lighter || 'rgba(33, 150, 243, 0.15)',
            color: theme.palette.info.main,
          }
        },
        outlined: {
          borderWidth: 1.5,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          }
        },
        light: {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.lighter,
          borderColor: theme.palette.primary.light,
          '&.MuiChip-lightError': {
            color: theme.palette.error.main,
            backgroundColor: theme.palette.error.lighter,
            borderColor: theme.palette.error.light
          },
          '&.MuiChip-lightSuccess': {
            color: theme.palette.success.main,
            backgroundColor: theme.palette.success.lighter,
            borderColor: theme.palette.success.light
          },
          '&.MuiChip-lightWarning': {
            color: theme.palette.warning.main,
            backgroundColor: theme.palette.warning.lighter,
            borderColor: theme.palette.warning.light
          }
        }
      }
    }
  };
}
